<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} WRCMS, All rights reserved.
  </p>
</footer>
<!--Footer Ends-->
